<template>
  <div class="card bg-light mb-3">
    <div class="card-header">
      <h5 class="card-title">
        <i class="fa fa-share-alt"></i>
        {{ $t('CHANNEL_SETTINGS_MISC_TITLE') }}:
      </h5>
    </div>

    <div class="card-body">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" id="shared_checkbox" name="customCheckbox" class="custom-control-input"
               v-model="settings.isShared">
        <label class="custom-control-label" for="shared_checkbox">{{ $t('CHANNEL_SETTINGS_MISC_CHECKBOX_LABEL_VIRTUAL') }}</label>
      </div>
      <div class="custom-control custom-checkbox">
        <input type="checkbox" id="autostream_checkbox" name="customCheckbox" class="custom-control-input"
               v-model="settings.enableAutoStream">
        <label class="custom-control-label" for="autostream_checkbox">{{ $t('CHANNEL_SETTINGS_MISC_CHECKBOX_LABEL_AUTOSTREAM') }}</label>
      </div>
      <!-- <div class="custom-control custom-checkbox">
        <input type="checkbox" id="visible_checkbox" name="customCheckbox" class="custom-control-input"
               v-model="settings.visible">
        <label class="custom-control-label" for="visible_checkbox">{{ $t('CHANNEL_SETTINGS_MISC_CHECKBOX_LABEL_VISIBLE') }}</label>
      </div> -->
      <div class="custom-control custom-checkbox">
        <input type="checkbox" id="isenabled_setting" name="customCheckbox" class="custom-control-input"
               v-model="settings.isEnabled">
        <label class="custom-control-label" for="isenabled_setting">{{ $t("CHANNEL_SETTINGS_MISC_CHECKBOX_LABEL_VISIBLE") }}</label>
      </div>
      <div class="custom-control custom-checkbox">
        <input type="checkbox" id="importAllRecordings_setting" name="customCheckbox" class="custom-control-input"
               v-model="settings.importAllRecordings">
        <label class="custom-control-label" for="importAllRecordings_setting">{{ $t("CHANNEL_SETTINGS_MISC_CHECKBOX_LABEL_IMPORTALL") }}</label>
      </div>

      <div class="form-group mt-2">
        <label for="settings_tags" class="label">{{ $t("CHANNEL_SETTINGS_MISC_TAGS") }}</label>
        <input type="text" id="settings_tags" v-model="settings.tags" class="form-control">
        <small class="text-muted">{{ $t("CHANNEL_SETTINGS_MISC_TAGS_NOTE") }}</small>
      </div>

      <div class="form-group mt-2">
        <label for="settings_desc" class="label">{{ $t("CHANNEL_SETTINGS_MISC_DESCRIPTION") }}</label>
        <input type="text" id="settings_desc" v-model="settings.description" class="form-control">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiscellaneousSettings',
  computed: {
    settings() {
      return this.$store.getters.getChannelSettings;
    },
  },
};
</script>

<style scoped>

</style>
